module.exports = __webpack_public_path__ + "static/media/man.1a423b5c.svg";